import React from "react";

const Spring = (props) => {
    const {
        x,
        y,
        angle,
        scale,
        width,
        length,
        girth,
        color,
        coils,
        strokeWidth,
        innerLines
    } = props;
    const wireRadius = width * girth/100;
    const leftAxisX = wireRadius;
    const rightAxisX = width - wireRadius;
    const yStep = ((length - 2*wireRadius)*2)/(2*coils-1);

    const drawCoilWires = () => {
        const result = [];
        for(let i = 0; i < coils; i++){
            result[i] = <circle 
                cx={rightAxisX}
                cy={wireRadius+(i*yStep)}
                r={wireRadius}
                stroke={color}
                strokeWidth={strokeWidth}
                key={i}
            />;
            result[i + coils] = <circle 
                cx={leftAxisX}
                cy={length-wireRadius-(i*yStep)}
                r={wireRadius}
                stroke={color}
                strokeWidth={strokeWidth}
                key={i + coils}
            />;
        };
        result.push(<path 
            d={`
                M ${0},${0}
                l ${wireRadius*2},${0}
                A ${wireRadius},${wireRadius} 0,1,1 ${0},${0}
                Z
            `}
            stroke={color}
            strokeWidth={strokeWidth}
            key={coils*2 + 2}
        />);
        result.push(<path 
            d={`
                M ${width},${length}
                l ${-wireRadius*2},${0}
                A ${wireRadius},${wireRadius} 0,1,1 ${width},${length}
                Z
            `}
            stroke={color}
            strokeWidth={strokeWidth}
            key={coils*2 + 3}
        />);
        return result;
    };
    const drawWhiteFills = () => {
        const keyOffset = 100;
        const result = [];
        if (innerLines) {
            for(let i = 0; i < (coils - 1); i++){
                result[i] = <polyline 
                    points={`
                        ${leftAxisX}, ${yStep/2 + yStep*i} 
                        ${rightAxisX}, ${yStep + yStep*i} 
                        ${rightAxisX}, ${yStep + yStep*i + wireRadius*2}
                        ${leftAxisX}, ${yStep/2 + yStep*i + wireRadius*2}
                        ${leftAxisX}, ${yStep/2 + yStep*i} 
                    `}
                    stroke={color}
                    strokeWidth={strokeWidth}
                    fill="white"
                    key={keyOffset + i}
                />
            } 
        } else return null;
        result[coils] = <polyline 
            points={`
                ${leftAxisX}, 0 
                ${rightAxisX}, 0 
                ${rightAxisX}, ${wireRadius*2}
                ${leftAxisX}, ${wireRadius}
                ${leftAxisX}, 0 
            `}
            stroke={color}
            strokeWidth={strokeWidth}
            fill="white"
            key={keyOffset+coils}
        />;
        result[coils+1] = <polyline 
            points={`
                ${leftAxisX}, ${length} 
                ${rightAxisX}, ${length} 
                ${rightAxisX}, ${length - wireRadius}
                ${leftAxisX}, ${length - wireRadius*2}
                ${leftAxisX}, ${length} 
            `}
            stroke={color}
            strokeWidth={strokeWidth}
            fill="white"
            key={keyOffset+coils+1}
        />;
        return result;
    };
    return(
        <g
            transform={`translate(${x}, ${y}) rotate(${angle}) scale(${scale})`}
        >
            {drawWhiteFills()}
            {drawCoilWires()}
        </g>
    );
}
export default Spring; 
